(function() {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('enhancedPayNowCtrl', [
    '$scope',
    '$rootScope',
    '$http',
    '$stateParams',
    '$modal',
    'data',
    '$state',
    '$sessionStorage',
    '$timeout',
    'httpService',
    'uteEndpoint',
    'commonService',
    'uteSemafoneService',
    'util',
    '$filter',
    'uteModal',
    'uteLocale',
    'dtmService',
    'dtmServiceConstants',
    '$translate',
    'dataLayerService',
    '$modalInstance',
    '$document',
    '$window',
    function(
      $scope,
      $rootScope,
      $http,
      $stateParams,
      $modal,
      data,
      $state,
      $sessionStorage,
      $timeout,
      httpService,
      uteEndpoint,
      commonService,
      uteSemafoneService,
      util,
      $filter,
      uteModal,
      uteLocale,
      dtmService,
      dtmServiceConstants,
      $translate,
      dataLayerService,
      $modalInstance,
      $document,
      $window
    ) {
      var self = {};
      var selfCardType = '';
      var subscriberCTN = '';
      var dtmRule = dtmServiceConstants.dtmRules.makePayment;
      var paymentInProgress = false;
      $scope.isSubscriber = false;
      if ($rootScope.userInfo.profileType.subscriber != null && $rootScope.userInfo.profileType.subscriber != '') {
        $scope.isSubscriber = $rootScope.userInfo.profileType.subscriber;
      }

      //initial text box classes
      $scope.getTextClass = 'black-font';
      $scope.getLabelClass = 'green-font';
      $scope.borderDown = 'successLine';

      $scope.$storage = $sessionStorage;
      $scope.language = uteLocale.language;
      $scope.isInteracPaymentSuccess = null;
      $scope.lessThanThreshold = false;
      $scope.thresholdAmountLimit = 1000; // Threshold Amount Limit confirmed by Business
      $scope.isNotValidCard = false;
      $scope.today = new Date();
      $scope.billingType = '';
      $scope.interacEligibilityError = false;
      $scope.isCancelledAccount = false;
      $scope.limitedOverPayAmount = null;
      $scope.maxLimitedOverPayAmount = null;
      commonService.deepLinkState = '';
      $scope.screenToRender = 'showPaymentSection';
      $scope.paymentStep = 'Payment';
      $scope.isModalWindow = true;
      $scope.isTryAgainDisabled = false;
      $scope.hideOverlimitMessage = false;
      $scope.closeOverlimitMessage = function() {
        $scope.hideOverlimitMessage = true;
      };
      $scope.errorPayload = {
        page: dtmServiceConstants.dataLayerTrack.page.makeAPayment.error
      };
      $scope.errorFormPayload = {
        page: dtmServiceConstants.dataLayerTrack.page.makeAPayment.start
      };

      $scope.paymentSteps = [
        {
          name: 'Payment',
          index: '1'
        },
        {
          name: 'Review',
          index: '2'
        },
        {
          name: 'Confirmation',
          index: '3'
        }
      ];
      $('.mobile-bank-payment-div').show();
      //FIA-487 New Date format for French
      $scope.newFrenchDate = function() {
        var today = new Date(),
          date = today.getDate(),
          month = 'janvier,février,mars,avril,mai,juin,juillet,août,septembre,octobre,novembre,décembre'.split(',')[
            today.getMonth()
          ];

        function nth(d) {
          if (d > 1 && d <= 31) return '';
          if ((d = 1)) return 'er'; // er for first day of every month in French.
        }
        var curDate = date + nth(date).sup() + ' ' + month + '' + ',' + ' ' + today.getFullYear();
        $scope.currentFrenchDate = curDate;
      };
      $scope.greyPaymentBox = function() {
        $('.mobile-payment-grey-border').addClass('border-left-2');
        $('.mobile-payment-grey-border').addClass('border-right-2');
        $('.mobile-bank-payment-div').hide();
      };
      // To observe and track changes in card validation
      $scope.isCardValid = false;
      $scope.$watch(
        function() {
          return _.isEmpty(uteSemafoneService.getMaskedCardNumber()) ? '' : uteSemafoneService.getMaskedCardNumber();
        },
        function(newVal, oldVal) {
          // console.log(' enhancedPayNow isCardValid watches isValidCard:', newVal,oldVal);
          // console.log('Get Masked :::', uteSemafoneService.getMaskedCardNumber());
          $scope.isCardValid = newVal.length > 0;
        }
      );
      $scope.goToPaymentSection = function(paymentType) {
        $scope.paymentStep = 'Payment';
        $scope.screenToRender = 'showPaymentSection';
        if (typeof paymentType != 'undefined' && paymentType == 'CC') {
          $scope.billingType = 'Creditcard';
          $timeout(function() {
            $scope.greyPaymentBox();
            $scope.inputEditable();
          });
        } else if (typeof paymentType != 'undefined' && paymentType == 'Interac') {
          $scope.billingType = 'Interac';
          $timeout(function() {
            $scope.greyPaymentBox();
            $scope.inputReadOnly();
          });
        } else if (typeof paymentType != 'undefined' && paymentType == 'Bank') {
          $scope.billingType = 'Bank';
          $timeout(function() {
            $scope.$apply(function() {
              $scope.greyPaymentBox();
              $scope.inputReadOnly();
            });
          });
        } else {
          if ($scope.errorType == 'CC-DATA-ERROR') {
            $scope.isTryAgainDisabled = true; //disable continue & review for Try again
          }
          if (!$scope.payment.hasWireless) {
            if ($scope.billingType != 'Creditcard') {
              $scope.billingType = '';
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('processing-modal')
                .addClass('open-screen-wireless');
              $('body.modal-open').addClass('disable-background-scroll');
            } else {
              $scope.billingType = 'Creditcard';
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('processing-modal')
                .addClass('open-screen-internet');
            }
            self.trackMakeAPayment(
              dtmServiceConstants.actions.startEvent,
              dtmServiceConstants.dataLayerTrack.basicPayloadSections
            );
          } else {
            if ($scope.billingType != 'Creditcard') {
              $scope.billingType = '';
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('processing-modal')
                .addClass('open-screen-wireless');
              $('body.modal-open').addClass('disable-background-scroll');
            } else {
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('processing-modal')
                .addClass('open-screen');
            }
            self.trackMakeAPayment(
              dtmServiceConstants.actions.startEvent,
              dtmServiceConstants.dataLayerTrack.basicPayloadSections
            );
          }
        }
      };

      $scope.onBlurListener = function() {
        $scope.isValidAmount(true);
        $scope.decimalFormat();
        $scope.payNow.amountOnFocus = false;
      };

      $scope.onFocusListener = function(payNowform) {
        $scope.resetTryAgainDisabled();
        $scope.resetAmountField(payNowform);
      };

      $scope.resetAmountField = function(formObj) {
        $scope.payNow.amountOnFocus = true;
        formObj.amount.$setPristine();
        formObj.amount.$setValidity();
        $scope.getTextClass = 'green-font';
        $scope.getLabelClass = 'green-font';
        $scope.borderDown = 'successLine';
      };

      $scope.resetTryAgainDisabled = function() {
        if ($scope.isTryAgainDisabled) {
          $scope.isTryAgainDisabled = false;
        }
      };

      $scope.showCvvPlaceholder = function() {
        if (typeof $scope.payNow.cvv != 'undefined' && $scope.payNow.cvv.length == 0) {
          $scope.showSmallLabel = false;
        } else if (typeof $scope.payNow.cvv == 'undefined') {
          var cvvText = angular.element('#cvv').val();
          if (cvvText.length > 0) {
            $scope.showSmallLabel = true;
            $scope.processCVV();
          } else {
            $scope.showSmallLabel = false;
          }
        }
      };
      $scope.setShowSmallLabel = function() {
        $scope.showSmallLabel = true;
      };
      $scope.processCVV = function() {
        $scope.cvvMaxLength = 4;
        $scope.cvvPlaceholder = 'global.label.paymentSecurityCode';
        $scope.cardCvvType = '';
        if (uteSemafoneService.getCardScheme() == 'VISA') {
          selfCardType = 'VS';
          $scope.cvvPlaceholder = 'global.label.visaMaster';
          $scope.cardCvvType = 'VS';
          $scope.cvvMaxLength = 3;
        } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
          selfCardType = 'AM';
          $scope.cvvPlaceholder = 'global.label.amex';
          $scope.cardCvvType = 'AM';
          $scope.cvvMaxLength = 4;
        } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
          selfCardType = 'MC';
          $scope.cvvPlaceholder = 'global.label.visaMaster';
          $scope.cardCvvType = 'MC';
          $scope.cvvMaxLength = 3;
        }
      };

      self.trackMakeAPayment = function(
        paymentStep,
        addBasicSections,
        billingType,
        paymentAmount,
        referenceNumber,
        isAutoPayment
      ) {
        var selfServe = {};
        var event = {};
        var page = dtmServiceConstants.dataLayerTrack.page.makeAPayment[paymentStep];

        /**
         * Set event for SelfServe Start or Complete
         */
        if (paymentStep === 'start') {
          event.selfServeStart = true;
          selfServe = dtmServiceConstants.dataLayerTrack.selfServe.makeAPayment;
          if (!_.isEmpty(selfServe.paymentMethod)) {
            delete selfServe.paymentMethod;
          }
          if (!_.isEmpty(selfServe.revenue)) {
            delete selfServe.revenue;
          }
          if (!_.isEmpty(selfServe.transactionID)) {
            delete selfServe.transactionID;
          }
        } else if (paymentStep === 'complete') {
          event.selfServeComplete = true;
          selfServe = dtmServiceConstants.dataLayerTrack.selfServe.makeAPayment;

          if (typeof billingType != 'undefined') {
            selfServe.paymentMethod = billingType;
            if (billingType.indexOf(dtmServiceConstants.dataLayerTrack.page.makeAPayment.paymentType.bank) > -1) {
              page = dtmServiceConstants.dataLayerTrack.page.makeAPayment.payViaBank;
            }
          }
          if (typeof paymentAmount != 'undefined') {
            selfServe.revenue = parseInt(paymentAmount).toFixed(2);
          }
          if (typeof referenceNumber !== 'undefined' && referenceNumber != null) {
            selfServe.transactionID = referenceNumber;
          }
          if (typeof isAutoPayment != 'undefined' && isAutoPayment == 'Success') {
            event.autopay = true;
          }
        }

        var payload = {
          page: page,
          selfServe: selfServe,
          events: event
        };

        /**
         * Remove empty objects from payload
         */
        if (_.isEmpty(payload.events)) {
          delete payload.events;
        }
        if (_.isEmpty(payload.selfServe)) {
          delete payload.selfServe;
        }
        dataLayerService.trackDataLayer(payload, $scope.isModalWindow, addBasicSections);
      };

      $scope.fetchBankList = function() {
        $http({
          method: 'GET',
          url: 'cms/ute/fido/resource/paymentBankList.json'
        })
          .success(function(data) {
            if (data && data.bankList) {
              if ($scope.language === 'en') {
                $scope.bankList = data.bankList.en && data.bankList.en.bank ? data.bankList.en.bank : '';
              } else {
                $scope.bankList = data.bankList.fr && data.bankList.fr.bank ? data.bankList.fr.bank : '';
              }
            } else {
              $scope.bankList = '';
            }
          })
          .error(function(response) {
            $scope.bankList = '';
          });
      };

      self.listenToEscapeKey = function() {
        $document.bind('keydown', function(evt) {
          if (evt.which === 27) {
            $scope.closeModal();
          }
        });
      };

      self.init = function() {
        self.listenToEscapeKey();
        $stateParams.isPayInteracResponse = null;
        $scope.newFrenchDate();
        $scope.processCVV();
        if ($rootScope.userInfo && ($rootScope.userInfo.accounts || []).length > 0) {
          if ($stateParams.accountNumber) {
            $scope.selectedAccountNumber = $stateParams.accountNumber;
            $scope.accountNumber = $scope.selectedAccountNumber;
          } else if (data && data.accountNumber) {
            $scope.selectedAccountNumber = data.accountNumber;
            $scope.accountNumber = $scope.selectedAccountNumber;
          } else if ($scope.$storage && $scope.$storage.selectedAccountNumber) {
            $scope.selectedAccountNumber = $scope.$storage.selectedAccountNumber;
            $scope.accountNumber = $scope.$storage.selectedAccountNumber;
          } else {
            $scope.selectedAccountNumber = $rootScope.userInfo.selectedAccountNumber
              ? $rootScope.userInfo.selectedAccountNumber
              : $rootScope.userInfo.accounts[0].accountNumber;
            $scope.accountNumber = $scope.selectedAccountNumber;
          }
        }

        if ($scope.selectedAccountNumber) {
          var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
            return String(account.accountNumber) === String($scope.selectedAccountNumber);
          });
          if (!!currentAccount) {
            var currentAccountStatus = currentAccount.status && currentAccount.status.toUpperCase();
            $scope.isSuspended = currentAccountStatus === 'SUSPENDED';
            $scope.isSelectedAccountCancelled = currentAccountStatus === 'CANCELLED';
          }
        }
        if (!$stateParams.response && data && data.response) {
          $stateParams.response = data.response;
        }
        if (data && !data.response) {
          self.trackMakeAPayment(
            dtmServiceConstants.actions.startEvent,
            dtmServiceConstants.dataLayerTrack.basicPayloadSections
          );
        }
        //Fetch list of bank codes
        $scope.fetchBankList();
      };
      self.init();

      if ($stateParams.accountNumber) {
        $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
        $rootScope.userInfo.selectedSubscriberNo = '';
      } else if (
        !$stateParams.accountNumber &&
        !$rootScope.userInfo.selectedAccountNumber &&
        !$scope.selectedAccountNumber
      ) {
        $state.go('myAccount.overview');
      } else {
        if (!$stateParams.accountNumber && data && data.accountNumber) {
          $stateParams.accountNumber = data.accountNumber;
          $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
          $rootScope.userInfo.selectedSubscriberNo = '';
        } else if (!$stateParams.accountNumber && $rootScope.userInfo.selectedAccountNumber) {
          $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
        } else {
          $stateParams.accountNumber = $rootScope.userInfo.accounts[0].accountNumber;
        }
      }

      $scope.payment = {};
      uteSemafoneService.clearData();

      $('.moneyOnly').keypress(function(e) {
        //TODO use directive in payment modular
        if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57) && e.which !== 44 && e.which !== 46) {
          return false;
        }
      });

      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //watch function only for desktop
        $scope.$watch(
          function() {
            return $('.pay-now-modal').height();
          },
          function(newValue, oldValue) {
            if (!$scope.$$phase) {
              $scope.$apply();
            }
            if (newValue != oldValue) {
              $('.paynow-circle-arrow').css({ 'padding-top': newValue / 2 - 60 + 'px' });
              console.log(newValue / 2 - 60);
              if (!$scope.$$phase) {
                $scope.$apply();
              }
            }
          }
        );
      }
      $scope.inputReadOnly = function() {
        $('#amount').prop('readonly', true);
      };
      $scope.inputEditable = function() {
        $('#amount').prop('readonly', false);
      };

      $scope.openNextScreen = function() {
        $scope.greyPaymentBox();
        if (/Android|webOS|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          //mobile browser
          $('.pay-now-modal-window').animate({ scrollTop: 600 }, 'slow');
        } else if (/iPhone|iPod/i.test(navigator.userAgent)) {
          // fix for DSO-6733: Fido: CC field typing issue (I/OS Safari Browser)
          $('.pay-now-modal-window').animate({ scrollTop: 1000 }, 'slow');
        }
        //$('body.modal-open').removeClass('disable-background-scroll');
        $('.pay-now-modal-window .modal-dialog')
          .removeClass('open-screen-wireless open-screen-internet processing-modal')
          .addClass('open-screen');
        self.trackMakeAPayment('details', dtmServiceConstants.dataLayerTrack.basicPayloadSections);
      };

      $scope.checkAccountStatus = function(accountNumber) {
        var currentAccount = _.find($rootScope.userInfo.accounts, function(account) {
          return account.accountNumber === accountNumber;
        });
        if (currentAccount && currentAccount.status && currentAccount.status.toUpperCase() === 'CANCELLED') {
          $scope.isCancelledAccount = true;
        } else {
          $scope.isCancelledAccount = false;
        }
        $scope.callDigest();
      };

      $scope.filterWirelessCFA = function(account) {
        return $rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless';
      };

      self.loadPaymentDetails = function() {
        var selectedAccountDetail;

        $rootScope.$emit('initPaymentDetailsModal');
        console.log('$scope.selectedAccountNumber', $scope.selectedAccountNumber);

        if ($scope.selectedAccountNumber) {
          selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
            return String(accountDetail.accountNumber) === String($scope.selectedAccountNumber);
          });
          console.log('selectedAccountDetail', selectedAccountDetail);
        }
        $scope.payment = {};

        if (selectedAccountDetail) {
          $scope.payment = {
            accountBalance: selectedAccountDetail.balance,
            date: selectedAccountDetail.paymentDueDate,
            hasWireless: selectedAccountDetail.hasWireless,
            MOPType: selectedAccountDetail.MOPType,
            enrollAutoPay: false
          };
        }

        if ($scope.payment.hasWireless && !_.isEmpty(selectedAccountDetail.subscriberServices)) {
          for (var i = 0; i < selectedAccountDetail.subscriberServices.length; i++) {
            if (
              selectedAccountDetail.subscriberServices[i].wireless != null &&
              selectedAccountDetail.subscriberServices[i].wireless.subscriberNo != null
            ) {
              subscriberCTN = selectedAccountDetail.subscriberServices[i].wireless.subscriberNo;
              break;
            }
          }
        }

        $timeout(function() {
          if ($scope.payment.hasWireless) {
            if ($stateParams.response == 'funded' || $scope.interacResponse === 'funded') {
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('open-screen-wireless')
                .addClass('open-screen');
            } else {
              $('.pay-now-modal-window .modal-dialog').addClass('open-screen-wireless');
              $('body.modal-open').addClass('disable-background-scroll');
            }
          } else {
            $('.pay-now-modal-window .modal-dialog').addClass('open-screen-wireless');
          }
        });
      };
      self.loadPaymentDetails();

      $scope.maxLimitedOverPayAmount = $scope.payment.accountBalance + $scope.thresholdAmountLimit;

      if (!$scope.payment.hasWireless && _.isEmpty($scope.payment.MOPType)) {
        $http({
          method: 'POST',
          url: uteEndpoint('v1/billingArrangementData'),
          data: {
            billingArrangementId: $scope.selectedAccountNumber
          }
        }).success(function(data) {
          $scope.payment.MOPType = data.methodOfPayment;
        });
      }

      $scope.checkForNegativeBalance = function() {
        if ($scope.payment.accountBalance < 0) {
          return 0;
        } else return $scope.payment.accountBalance;
      };

      $scope.payNow = {
        // form user input fields
        amount: $filter('number')($scope.checkForNegativeBalance(), 2)
      };

      var regExAmountEn = /^[\d,]*(?:\.\d{0,2})?$/;
      var regExAmountFr = /^[\d\s]*(?:\,\d{0,2})\s?$/;

      $scope.validAmountEn = regExAmountEn.test($scope.payNow.amount);
      $scope.validAmountFr = regExAmountFr.test($scope.payNow.amount);

      self.convertAmount = function(amountString) {
        if (!amountString) {
          return 0;
        } else if ($scope.validAmountEn && $scope.language == 'en') {
          return amountString.replace(/,/g, '');
        } else if ($scope.validAmountFr && $scope.language == 'fr') {
          return amountString.replace(/\s/g, '').replace(/,/g, '.');
        }
      };

      $scope.today = new Date();
      $scope.firstMonth = 1;
      $scope.setRange = function(min, max) {
        var months = [];
        for (var i = min; i <= max; i++) months.push(i);
        return months;
      };

      $scope.ccType;
      $scope.submitDisabled = false;

      $scope.payNowRule = {
        ccNumber: {
          pattern: '((([0-9]{4}[ -]?){4})|(([0-9]{4}[ -]?)([0-9]{6}[ -]?)([0-9]{5})))'
        },
        expMonth: {
          type: 'number',
          min: 1,
          max: 12
        },
        expYear: {
          type: 'number',
          min: 2017,
          max: 2027
        },
        cvv: {
          type: 'number',
          minlength: 3,
          maxlength: 4
        },
        ccName: {
          pattern: 'VISA|MASTER|AMEX'
        }
      };

      $scope.payNowAmountRule = {
        amount: {
          type: 'number',
          change: 'resetAPIErrorFlags()',
          min: 0.01
        }
      };

      $scope.isValidAmount = function(setClassName) {
        if (!$scope.payNow.amount) {
          if (setClassName) {
            $scope.getTextClass = 'red-font';
            $scope.getLabelClass = 'red-font';
            $scope.borderDown = 'errorLine';
          }
          return false;
        }
        if (($scope.validAmountEn || $scope.validAmountFr) && self.convertAmount($scope.payNow.amount) > 0) {
          /*$scope.getTextClass = "green-font";
           $scope.getLabelClass = "green-font";
           $scope.borderDown = "successLine";*/
          return true;
        } else {
          if (setClassName) {
            $scope.getTextClass = 'red-font';
            $scope.getLabelClass = 'red-font';
            $scope.borderDown = 'errorLine';
          }
          /* $scope.payNowform.amount.$touched = true;
           $scope.payNowform.amount.$setTouched();
           $scope.payNowform.amount.$setValidity('required', false);TODO*/
          return false;
        }
      };
      $scope.toFixed2 = function() {
        var payAmount = $scope.payNow.amount;
        if ($scope.language === 'fr' && !_.isEmpty(payAmount)) {
          if (payAmount.indexOf(',') !== -1) {
            payAmount = payAmount.slice(0, payAmount.indexOf(',') + 3);
          }
        } else if ($scope.language === 'en' && !_.isEmpty(payAmount)) {
          if (payAmount.indexOf('.') !== -1) {
            payAmount = payAmount.slice(0, payAmount.indexOf('.') + 3);
          }
        }
        $scope.payNow.amount = payAmount;
      };
      $scope.decimalFormat = function() {
        var payAmount = $scope.payNow.amount;
        if ($scope.language === 'fr' && !_.isEmpty(payAmount)) {
          payAmount = payAmount.replace(/\s+/g, '');
          var parsedFloatAmount = parseFloat(payAmount.replace(',', '.'));
          var finalAmount = parsedFloatAmount.toFixed(2).replace('.', ',');
          $scope.payNow.amount = finalAmount;
        } else if ($scope.language === 'en' && !_.isEmpty(payAmount)) {
          payAmount = payAmount.replace(/,/g, '');
          var payAmountDecimal = parseFloat(payAmount).toFixed(2);
          $scope.payNow.amount = payAmountDecimal;
        }
      };

      $scope.isValidAmountBalance = function(setClassName) {
        if (!$scope.isValidAmount()) {
          if (setClassName) {
            $scope.getTextClass = 'red-font';
            $scope.getLabelClass = 'red-font';
            $scope.borderDown = 'errorLine';
          }
          return false;
        }

        var convertedAmount = self.convertAmount($scope.payNow.amount);

        if ($scope.payment.accountBalance >= 0 && convertedAmount - $scope.payment.accountBalance > 0) {
          $scope.limitedOverPayAmount = convertedAmount - $scope.payment.accountBalance;
        } else {
          $scope.limitedOverPayAmount = convertedAmount;
        }

        if (convertedAmount <= $scope.payment.accountBalance) {
          $scope.lessThanThreshold = false;
          if (setClassName) {
            $scope.getTextClass = 'green-font';
            $scope.getLabelClass = 'green-font';
            $scope.borderDown = 'successLine';
          }
          return true;
        } else if (
          convertedAmount > $scope.payment.accountBalance &&
          convertedAmount <= $scope.payment.accountBalance + $scope.thresholdAmountLimit
        ) {
          $scope.lessThanThreshold = true;
          if (setClassName) {
            $scope.getTextClass = 'green-font';
            $scope.getLabelClass = 'green-font';
            $scope.borderDown = 'successLine';
          }
          //$scope.payNowform.amount.$setValidity('required', true); TODO
          return false;
        } else {
          $scope.lessThanThreshold = false;
          if (setClassName) {
            $scope.getTextClass = 'red-font';
            $scope.getLabelClass = 'red-font';
            $scope.borderDown = 'errorLine';
          }
          //$scope.payNowform.amount.$setValidity('required', false);
          return false;
        }
      };

      $scope.callDigest = function() {
        if (!$scope.$$phase) {
          //$digest or $apply to make sure that the view is getting updated when scope changes
          $scope.$apply();
        }
      };

      $scope.validatePaymentAmount = function(form) {
        $scope.interacEligibilityError = false;
        var convertedAmount = self.convertAmount($scope.payNow.amount);
        if ($scope.billingType.toLowerCase() === 'creditcard') {
          util.validateFormOnSubmit(form);
          if (
            !form.$valid ||
            ($scope.payNow.expYear == $scope.today.getFullYear() &&
              $scope.payNow.expMonth <= $scope.today.getMonth()) ||
            !$scope.isValidAmount() ||
            (!$scope.isValidAmountBalance() && convertedAmount <= 0) ||
            convertedAmount > $scope.payment.accountBalance + $scope.thresholdAmountLimit
          ) {
            if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
              $scope.isNotValidCard = true;
              $translate('global.error.inline.creditCard.numberInvalid').then(function(translatedValues) {
                var dtmErrors = [];
                dtmErrors.push({
                  type: dtmServiceConstants.dataLayerTrack.errorType.form,
                  code: '',
                  message: translatedValues,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  field: 'credit card number'
                });
                dataLayerService.trackErrors(
                  $scope.errorFormPayload,
                  dtmErrors,
                  $scope.isModalWindow,
                  dtmServiceConstants.dataLayerTrack.basicPayloadInfo
                );
              });
            }
            return;
          } else {
            $scope.processCCValidation();
          }
        } else if ($scope.billingType.toLowerCase() === 'interac') {
          if (
            !$scope.isValidAmount() ||
            (!$scope.isValidAmountBalance() && convertedAmount <= 0) ||
            convertedAmount > $scope.payment.accountBalance + $scope.thresholdAmountLimit
          ) {
            return;
          } else {
            $scope.processInterac();
          }
        }
      };

      $scope.isDisabled = function() {
        var convertedAmount = self.convertAmount($scope.payNow.amount);
        var cvvText = angular.element('#cvv').val();
        var cvvIsNumber = /^[0-9]+$/.test(cvvText);
        if ($scope.billingType.toLowerCase() === 'creditcard') {
          if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
            if ($scope.isTryAgainDisabled) {
              $scope.isTryAgainDisabled = false;
            }
          }
          if (
            ($scope.payNow.expYear == $scope.today.getFullYear() &&
              $scope.payNow.expMonth <= $scope.today.getMonth()) ||
            typeof $scope.payNow.expYear == 'undefined' ||
            typeof $scope.payNow.expMonth == 'undefined' ||
            uteSemafoneService.getMaskedCardNumber() == null ||
            uteSemafoneService.getMaskedCardNumber() == '' ||
            (typeof $scope.payNow.cvv == 'undefined' && cvvText.length < 3) ||
            (typeof $scope.payNow.cvv != 'undefined' && $scope.payNow.cvv.length < 3) ||
            !$scope.isValidAmount() ||
            (!$scope.isValidAmountBalance() && convertedAmount <= 0) ||
            convertedAmount > $scope.payment.accountBalance + $scope.thresholdAmountLimit
          ) {
            return true;
          }
          if (
            ((uteSemafoneService.getCardScheme() == 'VISA' || uteSemafoneService.getCardScheme() == 'MASTERCARD') &&
              (cvvText.length < 3 || cvvText.length > 3)) ||
            (uteSemafoneService.getCardScheme() == 'AMEX' && cvvText.length < 4)
          ) {
            return true;
          }
          if (!cvvIsNumber) {
            return true;
          }
        } else if ($scope.billingType.toLowerCase() === 'interac') {
          if (
            !$scope.isValidAmount() ||
            (!$scope.isValidAmountBalance() && convertedAmount <= 0) ||
            convertedAmount > $scope.payment.accountBalance + $scope.thresholdAmountLimit
          ) {
            return true;
          }
        }
        return false;
      };

      $scope.processCCValidation = function() {
        if (uteSemafoneService.getCardScheme() == 'VISA') {
          selfCardType = 'VS';
        } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
          selfCardType = 'AM';
        } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
          selfCardType = 'MC';
        }

        $scope.payment.amount = self.convertAmount($scope.payNow.amount);
        var cvvLength = document.getElementById('cvv').value.length;
        $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
        $scope.payment.maskedToken = uteSemafoneService.getToken();
        $scope.payment.ccType = uteSemafoneService.getCardScheme();

        if ($scope.payment.ccType == 'VISA') {
          $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/visa-icon-1217.png';
          $scope.cardType = 'visa-card';
        }
        if ($scope.payment.ccType == 'AMEX') {
          $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/amex-icon.png';
          $scope.cardType = 'amex-card';
        }
        if ($scope.payment.ccType == 'MASTERCARD') {
          $scope.cardTypeSrc = '/html-fido/cms/ute/fido/images/mc.png';
          $scope.cardType = 'mc-card';
        }

        if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
          $scope.isNotValidCard = true;
          //notifier.notify.error({errorCode: 'cybinvalid'});
          $scope.screenToRender = 'showPaymentSection';
          $scope.paymentStep = 'Payment';
        } else {
          console.log('$scope.payment ready', $scope.payment);
          $scope.screenToRender = 'showPaymentSection';
          $scope.paymentStep = 'Review';
          self.trackMakeAPayment(
            $scope.paymentStep.toLowerCase(),
            dtmServiceConstants.dataLayerTrack.basicPayloadSections
          );
        }
      };

      $scope.processPayment = function(flag) {
        if (paymentInProgress) {
          return;
        }
        paymentInProgress = true;
        var paymentHistoryRecords = [];
        $scope.paymentHistoryReferenceNumber = '';
        $('.pay-now-modal-window .modal-dialog')
          .removeClass('open-screen-internet open-screen')
          .addClass('processing-modal');
        $('body.modal-open').addClass('disable-background-scroll');
        $scope.submitDisabled = true;
        $scope.screenToRender = 'processing';
        $scope.billingType == 'Creditcard';
        if ($scope.payNow.expMonth > 0 && $scope.payNow.expMonth < 10) {
          self.expMonth = '0' + $scope.payNow.expMonth;
        } else {
          self.expMonth = $scope.payNow.expMonth;
        }

        $http({
          method: 'POST',
          url: uteEndpoint('v1/payment/makePaymentAndUpdateMopToCC'),
          data: {
            'CreditCardInfo.ccType': selfCardType,
            'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
            'CreditCardInfo.ccExpiryMonth': self.expMonth,
            'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
            'CreditCardInfo.securityCode': $scope.payNow.cvv,
            amount: self.convertAmount($scope.payNow.amount),
            accountNumber: $stateParams.accountNumber,
            ctn: subscriberCTN,
            dupPayment: flag ? true : false,
            oldMop: $scope.payment.MOPType,
            enrollAutoPayment: $scope.payment.enrollAutoPay ? 'yes' : 'no'
          }
        })
          .success(function(data, status, headers, config) {
            paymentInProgress = false;
            if (data.error === '60006') {
              //duplicate payments
              $scope.screenToRender = 'serverError';
              $scope.submitDisabled = false;
              $scope.errorMsg = data;
              console.log(data);
              $scope.errorType = 'DUPLICATE-PAYMENTS';
              $translate('global.error.postBack.payment.duplicatePayment').then(function(translatedValues) {
                var dtmErrors = [];
                dtmErrors.push({
                  type: dtmServiceConstants.dataLayerTrack.errorType.credit,
                  code: angular.isString(data.error) ? data.error : '',
                  message: translatedValues,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.payment
                });
                dataLayerService.trackErrors(
                  $scope.errorPayload,
                  dtmErrors,
                  $scope.isModalWindow,
                  dtmServiceConstants.dataLayerTrack.basicPayloadSections
                );
              });
            } else if (data.error) {
              //If server returns an error
              $scope.screenToRender = 'serverError';
              $scope.submitDisabled = false;
              $scope.errorMsg = data;
              console.log(data);
              $scope.errorType = 'CC-DATA-ERROR';
              switch (data.error) {
                case '10645':
                  $scope.errorMsgToDisplay = 'global.error.postBack.payment.ccError-10645';
                  break;
                case '1005972':
                  $scope.errorMsgToDisplay = 'global.error.postBack.payment.ccError-1005972';
                  break;
                default:
                  $scope.errorMsgToDisplay = 'global.error.postBack.payment.ccError';
              }

              $translate($scope.errorMsgToDisplay).then(function(translatedValues) {
                var dtmErrors = [];
                dtmErrors.push({
                  type:
                    angular.isString(data.error) &&
                    (data.error === '10645' ||
                      data.error === '1005972' ||
                      data.error === 'soapenv:Server.userException')
                      ? dtmServiceConstants.dataLayerTrack.errorType.credit
                      : dtmServiceConstants.dataLayerTrack.errorType.http,
                  code: angular.isString(data.error) ? data.error : '',
                  message: translatedValues + ', ' + dtmRule.creditCardPaymentError,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.payment
                });
                dataLayerService.trackErrors(
                  $scope.errorPayload,
                  dtmErrors,
                  $scope.isModalWindow,
                  dtmServiceConstants.dataLayerTrack.basicPayloadSections
                );
              });
            } else {
              //Dc-2023 - making v2/paymentHistory api call only for reference number
              //setting reference number from makePayment api
              if (data && data.referenceNumber != '' && data.referenceNumber != null) {
                $scope.paymentHistoryReferenceNumber = data.referenceNumber;
              }
              $http({
                method: 'POST',
                url: uteEndpoint('v2/paymentHistory'),
                data: {
                  accountNumber: $stateParams.accountNumber
                }
              })
                .success(function(
                  paymentHistoryData,
                  paymentHistoryStatus,
                  paymentHistoryHeaders,
                  paymentHistoryConfig
                ) {
                  if (_.get(paymentHistoryData, 'getPaymentHistory.en.records', []).length) {
                    paymentHistoryRecords = paymentHistoryData.getPaymentHistory.en.records.filter(function(item) {
                      return (
                        item.paymentAmount == self.convertAmount($scope.payNow.amount) &&
                        item.paymentDate == $scope.formattedDate()
                      );
                    });
                    //resetting reference number from payment history api - DC-2023
                    if (paymentHistoryRecords.length > 1) {
                      $scope.paymentHistoryReferenceNumber = Math.max.apply(
                        Math,
                        paymentHistoryRecords.map(function(o) {
                          return o.referenceNumber;
                        })
                      );
                    } else if (paymentHistoryRecords.length === 1) {
                      $scope.paymentHistoryReferenceNumber = paymentHistoryRecords[0].referenceNumber;
                    }
                    $scope.processPaymentSuccess(data, status, headers, config, $scope.paymentHistoryReferenceNumber);
                  } else {
                    $scope.processPaymentSuccess(data, status, headers, config, $scope.paymentHistoryReferenceNumber);
                  }
                })
                .error(function(paymentHistoryData, paymentHistoryStatus) {
                  $scope.processPaymentSuccess(data, status, headers, config, $scope.paymentHistoryReferenceNumber);
                });
            }
          })
          .error(function(data, status) {
            paymentInProgress = false;
            $scope.screenToRender = 'serverError';
            $scope.submitDisabled = false;
            $scope.errorMsg = data;
            console.log(data);
            $scope.errorType = 'HTTP-ERROR';

            $translate('global.error.postBack.payment.serverError').then(function(translatedValues) {
              var dtmErrors = [];
              dtmErrors.push({
                type: $scope.getErrorType(status),
                code: status ? status : '',
                message: translatedValues + ', ' + dtmRule.creditCardPaymentError,
                category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.payment
              });
              dataLayerService.trackErrors(
                $scope.errorPayload,
                dtmErrors,
                $scope.isModalWindow,
                dtmServiceConstants.dataLayerTrack.basicPayloadSections
              );
            });
          });
      };

      $scope.getErrorType = function(status) {
        switch (status) {
          case 555:
            return dtmServiceConstants.dataLayerTrack.errorType.credit;
          case 440:
            return dtmServiceConstants.dataLayerTrack.errorType.user;
          default:
            return dtmServiceConstants.dataLayerTrack.errorType.http;
        }
      };

      $scope.formattedDate = function() {
        return $filter('date')($scope.today, 'dd/MM/yyyy');
      };

      $scope.processPaymentSuccess = function(data, status, headers, config, paymentHistoryReferenceNumber) {
        $('.pay-now-modal-window .modal-dialog')
          .addClass('processing-modal')
          .removeClass('open-screen');
        $scope.screenToRender = 'paymentSuccess';
        $timeout(function() {
          $('body.modal-open').removeClass('disable-background-scroll');
          if (data) {
            if (paymentHistoryReferenceNumber) {
              $scope.paymentReferenceNumberExists = true;
              $scope.paymentReferenceNumber = paymentHistoryReferenceNumber;
            }
            if ($scope.selectedAccountNumber) {
              var selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
                return String(accountDetail.accountNumber) === String($scope.selectedAccountNumber);
              });
              selectedAccountDetail.balance = $scope.payment.accountBalance - self.convertAmount($scope.payNow.amount);
              if (data.autoPaymentEnabled == 'success') {
                selectedAccountDetail.MOPType = 'pacc';
              }
            }
            if (data.autoPaymentEnabled == 'success') {
              $scope.autoPayStatus = 'Success';
            } else if (data.autoPaymentEnabled == 'failure') {
              $scope.autoPayStatus = 'Failure';

              $translate('global.label.PaymentAutoPayFailure').then(function(translatedValues) {
                var dtmErrors = [];
                dtmErrors.push({
                  type: dtmServiceConstants.dataLayerTrack.errorType.http,
                  code: '',
                  message: translatedValues,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.preAuthPayment
                });
                dataLayerService.trackErrors(
                  $scope.errorPayload,
                  dtmErrors,
                  $scope.isModalWindow,
                  dtmServiceConstants.dataLayerTrack.basicPayloadSections
                );
              });
            } else {
              $scope.autoPayStatus = '';
            }
          }
          $scope.screenToRender = 'showPaymentSection';
          $scope.paymentStep = 'Confirmation';
          $('.pay-now-modal-window .modal-dialog')
            .addClass('open-screen')
            .removeClass('processing-modal');
          var dtmCardType = 'credit/debit';
          if (selfCardType == 'VISA' || selfCardType == 'VS') {
            dtmCardType = dtmCardType + ' - VISA';
          } else if (selfCardType == 'MASTERCARD' || selfCardType == 'MC') {
            dtmCardType = dtmCardType + ' - MASTERCARD';
          } else if (selfCardType == 'AMEX' || selfCardType == 'AM') {
            dtmCardType = dtmCardType + ' - AMERICANEXPRESS';
          }
          self.trackMakeAPayment(
            dtmServiceConstants.actions.completeEvent,
            dtmServiceConstants.dataLayerTrack.basicPayloadSections,
            dtmCardType,
            $scope.payNow.amount,
            $scope.paymentReferenceNumber,
            $scope.autoPayStatus
          );
        }, 2000);
      };

      $scope.processInterac = function() {
        $scope.$storage.selectedAccountNumber = $scope.accountNumber;
        $scope.$storage.paymentAmount = self.convertAmount($scope.payNow.amount);
        $('body.modal-open').addClass('disable-background-scroll');
        var promise = httpService.send('v1/paynow/interac/payment/eligibility/check', {
          accountNumber: $scope.accountNumber,
          ctn: subscriberCTN,
          payNowAmount: self.convertAmount($scope.payNow.amount),
          language: $scope.language
        });

        promise.then(
          function(result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.interacEligibilityError = true;
              $scope.errorType = 'Interac-DATA-ERROR';
              $scope.screenToRender = 'serverError';
              $('.pay-now-modal-window .modal-dialog')
                .removeClass('open-screen')
                .addClass('processing-modal');
              $translate('global.error.postBack.payment.interacError').then(function(translatedValues) {
                var dtmErrors = [];
                dtmErrors.push({
                  type: dtmServiceConstants.dataLayerTrack.errorType.http,
                  code: angular.isString(result.data.error) ? result.data.error : '',
                  message: translatedValues + ', ' + dtmRule.interacPaymentEligibilityError,
                  category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.interacEligibility
                });
                dataLayerService.trackErrors(
                  $scope.errorPayload,
                  dtmErrors,
                  $scope.isModalWindow,
                  dtmServiceConstants.dataLayerTrack.basicPayloadSections
                );
              });
            } else {
              //alert('Postpaid Interac - checkPaymentEligibility - Successful');
              $scope.interacEligibilityInfo = result.data;
              $scope.MERCHANT_NUMBER = $scope.interacEligibilityInfo.interacParameters.IDEBIT_MERCHNUM;
              $scope.IDEBIT_MERCHDATA = $scope.interacEligibilityInfo.interacParameters.IDEBIT_MERCHDATA;
              $scope.IDEBIT_INVOICE = $scope.interacEligibilityInfo.interacParameters.IDEBIT_INVOICE;
              $scope.IDEBIT_TERMID = $scope.interacEligibilityInfo.interacParameters.IDEBIT_TERMID;
              $scope.INTERAC_SUCCESS_URL = $scope.interacEligibilityInfo.interacParameters.IDEBIT_FUNDEDURL;
              $scope.INTERAC_FAILURE_URL = $scope.interacEligibilityInfo.interacParameters.IDEBIT_NOTFUNDEDURL;
              $scope.IDEBIT_MERCHLANG = $scope.interacEligibilityInfo.interacParameters.IDEBIT_MERCHLANG;
              $scope.IDEBIT_AMOUNT = $scope.interacEligibilityInfo.interacParameters.IDEBIT_AMOUNT;
              $scope.callDigest();
              $('#uteInteracForm').attr('action', $scope.interacEligibilityInfo.interacParameters.INTERAC_URL);

              self.trackMakeAPayment('review', dtmServiceConstants.dataLayerTrack.basicPayloadSections);

              //alert('Postpaid Interac - checkPaymentEligibility - Going to submit the form');
              $timeout(function() {
                $('#uteInteracForm').submit();
              });
            }
          },
          function(reason) {
            $scope.interacEligibilityError = true;
            $scope.errorType = 'HTTP-ERROR';
            $scope.screenToRender = 'serverError';
            $('.pay-now-modal-window .modal-dialog')
              .removeClass('open-screen')
              .addClass('processing-modal');
            $translate('global.error.postBack.payment.serverError').then(function(translatedValues) {
              var dtmErrors = [];
              dtmErrors.push({
                type:
                  reason.status === 555
                    ? dtmServiceConstants.dataLayerTrack.errorType.credit
                    : dtmServiceConstants.dataLayerTrack.errorType.http,
                code: reason.status ? reason.status : '',
                message: translatedValues + ', ' + dtmRule.interacPaymentEligibilityError,
                category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.interacEligibility
              });
              dataLayerService.trackErrors(
                $scope.errorPayload,
                dtmErrors,
                $scope.isModalWindow,
                dtmServiceConstants.dataLayerTrack.basicPayloadSections
              );
            });
          }
        );
      };
      if ($stateParams.response) {
        console.log('interac response:' + $stateParams.response);
        if ($scope.$storage.selectedAccountNumber && $scope.$storage.paymentAmount) {
          $scope.interacResponse = $stateParams.response;
          $scope.selectedAccountNumber = $scope.$storage.selectedAccountNumber;
          $scope.accountNumber = $scope.$storage.selectedAccountNumber;
          $scope.$storage.selectedAccountNumber = null;
          if ($scope.interacResponse === 'funded') {
            $scope.isInteracPaymentSuccess = true;
            var promise = httpService.send('v1/paynow/interac/payment/confirmation', {
              accountNumber: $scope.accountNumber
            });

            promise.then(
              function(result) {
                if (result.data.error || result.data.errorCode || result.data.status == 'Failed') {
                  $('.pay-now-modal-window .modal-dialog')
                    .removeClass('open-screen-wireless open-screen')
                    .addClass('processing-modal');
                  $('body.modal-open').addClass('disable-background-scroll');
                  $scope.interacPaymentInfoError = true;
                  $scope.errorType = 'Interac-DATA-ERROR';
                  $scope.screenToRender = 'serverError';
                  $stateParams.response = '';
                  $scope.$storage.paymentAmount = '';
                  $translate('global.error.postBack.payment.interacError').then(function(translatedValues) {
                    var dtmErrors = [];
                    dtmErrors.push({
                      type: dtmServiceConstants.dataLayerTrack.errorType.http,
                      code: angular.isString(result.data.error) ? result.data.error : '',
                      message: translatedValues,
                      category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                      API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.interacPaymentConfirm
                    });
                    dataLayerService.trackErrors(
                      $scope.errorPayload,
                      dtmErrors,
                      $scope.isModalWindow,
                      dtmServiceConstants.dataLayerTrack.basicPayloadSections
                    );
                  });
                } else {
                  $('body.modal-open').removeClass('disable-background-scroll');
                  $scope.billingType = 'interac';
                  $stateParams.response = '';
                  if ($scope.$storage.paymentAmount) {
                    $scope.payNow.amount = String($scope.$storage.paymentAmount);
                    $scope.payment.amount = String($scope.$storage.paymentAmount);
                    $scope.$storage.paymentAmount = '';
                  }
                  if ($scope.selectedAccountNumber) {
                    var selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
                      return String(accountDetail.accountNumber) === String($scope.selectedAccountNumber);
                    });
                    if (angular.isDefined($scope.payment.accountBalance) && angular.isDefined($scope.payNow.amount)) {
                      selectedAccountDetail.balance =
                        $scope.payment.accountBalance - self.convertAmount($scope.payNow.amount);
                    }
                  }
                  if (result.data && result.data.authorizationCode != '' && result.data.authorizationCode != null) {
                    $scope.paymentReferenceNumberExists = true;
                    $scope.paymentReferenceNumber = result.data.authorizationCode;
                  }
                  $scope.screenToRender = 'showPaymentSection';
                  $scope.paymentStep = 'Confirmation';
                  $('.pay-now-modal-window .modal-dialog')
                    .removeClass('open-screen-wireless processing-modal')
                    .addClass('open-screen');
                  self.trackMakeAPayment(
                    dtmServiceConstants.actions.completeEvent,
                    dtmServiceConstants.dataLayerTrack.basicPayloadSections,
                    dtmServiceConstants.dataLayerTrack.page.makeAPayment.paymentType.interac,
                    $scope.payNow.amount,
                    $scope.paymentReferenceNumber
                  );
                }
              },
              function(reason) {
                $scope.interacPaymentInfoError = true;
                $scope.screenToRender = 'serverError';
                $scope.errorType = 'HTTP-ERROR';
                $scope.$storage.paymentAmount = '';
                $stateParams.response = '';
                $('body.modal-open').addClass('disable-background-scroll');
                $('.pay-now-modal-window .modal-dialog')
                  .removeClass('open-screen-wireless open-screen')
                  .addClass('processing-modal');
                $translate('global.error.postBack.payment.serverError').then(function(translatedValues) {
                  var dtmErrors = [];
                  dtmErrors.push({
                    type:
                      reason.status === 555
                        ? dtmServiceConstants.dataLayerTrack.errorType.credit
                        : dtmServiceConstants.dataLayerTrack.errorType.http,
                    code: reason.status ? reason.status : '',
                    message: translatedValues,
                    category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                    API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.interacPaymentConfirm
                  });
                  dataLayerService.trackErrors(
                    $scope.errorPayload,
                    dtmErrors,
                    $scope.isModalWindow,
                    dtmServiceConstants.dataLayerTrack.basicPayloadSections
                  );
                });
              }
            );
          } else if ($scope.interacResponse === 'notFunded') {
            $scope.billingType = 'Interac';
            $scope.isInteracPaymentSuccess = false;
            $scope.errorType = 'Interac-DATA-ERROR';
            $scope.screenToRender = 'serverError';
            $scope.$storage.paymentAmount = '';
            $stateParams.response = '';
            $('body.modal-open').addClass('disable-background-scroll');
            $translate('global.error.postBack.payment.interacError').then(function(translatedValues) {
              var dtmErrors = [];
              dtmErrors.push({
                type: dtmServiceConstants.dataLayerTrack.errorType.selfServe,
                code: '',
                message: translatedValues,
                category: dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                API: dtmServiceConstants.dataLayerTrack.page.makeAPayment.errorType.interacPaymentFailure
              });
              dataLayerService.trackErrors(
                $scope.errorPayload,
                dtmErrors,
                $scope.isModalWindow,
                dtmServiceConstants.dataLayerTrack.basicPayloadSections
              );
            });
          } else {
            console.log('Not a Valid Response from Interac');
            $scope.$storage.paymentAmount = '';
            $stateParams.response = '';
            self.trackMakeAPayment(
              dtmServiceConstants.actions.startEvent,
              dtmServiceConstants.dataLayerTrack.basicPayloadSections
            );
          }
        } else {
          console.log('Not Having values in localstorage');
          $stateParams.response = '';
          self.trackMakeAPayment(
            dtmServiceConstants.actions.startEvent,
            dtmServiceConstants.dataLayerTrack.basicPayloadSections
          );
        }
      }

      $scope.processDupPayments = function() {
        $scope.processPayment(true);
      };

      $scope.cancel = function() {
        $scope.enableMobileScroll();
        $state.go('myAccount.overview');
      };

      $scope.enableMobileScroll = function() {
        $('body.modal-open').removeClass('disable-background-scroll');
      };

      $scope.closeModal = function() {
        $modalInstance.close({
          paymentStep: $scope.paymentStep,
          billingType: $scope.billingType
        });
      };

      $scope.redirectToBankSite = function(bank) {
        $scope.selectedBank = {};
        if (typeof bank != 'undefined' && $scope.billingType == 'Bank') {
          $scope.paymentStep = 'Confirmation';
          $scope.selectedBank = {
            image: bank.imagePath,
            name: bank.name,
            url: bank.url
          };
          var selectedBank =
            dtmServiceConstants.dataLayerTrack.page.makeAPayment.paymentType.bank + $scope.selectedBank.name;
          self.trackMakeAPayment(
            dtmServiceConstants.actions.completeEvent,
            dtmServiceConstants.dataLayerTrack.basicPayloadSections,
            selectedBank,
            $scope.payNow.amount
          );
          $window.open($scope.selectedBank.url, '_blank');
        }
      };
    }
  ]);
})();
